var React = require('react');

function Account (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"id":"account-icon-a","d":"M10 0a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm0 11.25c-3.338 0-10 1.675-10 5V20h20v-3.75c0-3.325-6.662-5-10-5z"})),React.createElement("g",{"fill":"none","fillRule":"evenodd","transform":"translate(2 2)","key":1},[React.createElement("mask",{"id":"account-icon-b","fill":"#fff","key":0},React.createElement("use",{"xlinkHref":"#account-icon-a"})),React.createElement("use",{"fill":"#FFF","xlinkHref":"#account-icon-a","key":1}),React.createElement("g",{"fill":"#FFF","mask":"url(#account-icon-b)","key":2},React.createElement("path",{"d":"M-2-2h24v24H-2z"}))])]);
}

Account.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Account;

Account.default = Account;
